/* File contain all API endpoints */

/* Auth EP */
const getCurrentUser = '/auth/getMe';


/* Anime EP */
const getAnimeWatchList = '/features/getWatchlist';

const api = {
   getCurrentUser,
   getAnimeWatchList
}

export default api;